import { Controller } from "@hotwired/stimulus"

// Handles textarea parsing, live count, duplicate detection, and limit validation
// for the bulk add guests slideover form.
// Does NOT handle: side toggle (side-select controller), form submission (Turbo),
// slideover open/close (slideover controller).
export default class extends Controller {
  static targets = [
    "textarea", "guestCount", "slotsRemaining", "submitBtn",
    "duplicateWarning", "duplicateText",
    "limitError", "limitErrorText"
  ]

  static values = {
    guestLimit: Number,     // 0 = unlimited
    currentCount: Number,
    existingNames: Array
  }

  connect() {
    this.parse()
  }

  parse() {
    const names = this.parseNames()
    const count = names.length

    this.guestCountTarget.textContent = `${count} guest${count !== 1 ? 's' : ''} detected`
    this.submitBtnTarget.textContent = `Add ${count} guest${count !== 1 ? 's' : ''}`
    this.submitBtnTarget.disabled = count === 0

    this.checkDuplicates(names)
    this.checkLimit(count)
  }

  parseNames() {
    return this.textareaTarget.value
      .split("\n")
      .map(line => line.trim())
      .filter(line => line.length > 0)
      .map(line => line.replace(/^\d+[\.\)\-\s]+/, '').trim())
      .filter(line => line.length >= 2)
      .filter((name, index, arr) => arr.indexOf(name) === index)
  }

  checkDuplicates(names) {
    if (!this.hasExistingNamesValue || this.existingNamesValue.length === 0) {
      this.duplicateWarningTarget.classList.add("hidden")
      return
    }

    const existing = this.existingNamesValue.map(n => n.toLowerCase())
    const dupes = names.filter(n => existing.includes(n.toLowerCase()))

    if (dupes.length > 0) {
      this.duplicateWarningTarget.classList.remove("hidden")
      this.duplicateTextTarget.textContent = `${dupes.length} possible duplicate${dupes.length !== 1 ? 's' : ''}`
    } else {
      this.duplicateWarningTarget.classList.add("hidden")
    }
  }

  checkLimit(count) {
    if (this.guestLimitValue === 0 || count === 0) {
      this.limitErrorTarget.classList.add("hidden")
      this.submitBtnTarget.disabled = count === 0
      return
    }

    const remaining = Math.max(this.guestLimitValue - this.currentCountValue, 0)
    this.slotsRemainingTarget.textContent = `${remaining} slot${remaining !== 1 ? 's' : ''} remaining`

    if (count > remaining) {
      this.limitErrorTarget.classList.remove("hidden")
      this.limitErrorTextTarget.textContent =
        `You're adding ${count} guests but only have ${remaining} slot${remaining !== 1 ? 's' : ''} remaining.`
      this.submitBtnTarget.disabled = true

      this.textareaTarget.classList.remove("border-gray-300", "focus:ring-teal-500", "focus:border-teal-500")
      this.textareaTarget.classList.add("border-red-300", "focus:ring-red-500", "focus:border-red-500")
    } else {
      this.limitErrorTarget.classList.add("hidden")
      this.submitBtnTarget.disabled = false

      this.textareaTarget.classList.remove("border-red-300", "focus:ring-red-500", "focus:border-red-500")
      this.textareaTarget.classList.add("border-gray-300", "focus:ring-teal-500", "focus:border-teal-500")
    }
  }
}
